import docready from "./docready";
import {isString} from "util";

export default class simpleModal {
    /**
     *
     * @param options
     *  * id - required. Modal id.
     *  * closeButton
     */
    constructor(options = {}) {
        // opener - the element opened the modal. By default, it will take focus after modal close.
        this.setOpener(options.opener || null);
        // @todo: remove options.small, options.bodyClass. Use scss to replace functionalty.
        this.id = options.id;
        const titleid = options.id + '__title';
        const labelStr = options.header !== false ? `aria-labelledby="${titleid}"` : '';
        const closeTitle = 'Close';
        const closeButton = typeof options.closeButton !== "undefined" ? options.closeButton : true;
        let html = `<div class="window ${(options.small || false) ? ' small' : ''}" role="alertdialog" ${labelStr} id="${options.id}">`;
        if (closeButton) {
            html += `<svg viewBox="0 0 20 20" class="svg-sprite svg-sprite-main window-close" aria-label="${closeTitle}" data-action="close" tabindex="0"><title>${closeTitle}</title><use xlink:href="#icon-cross-circled-inverted"></use></svg>`;
        }
        if (options.headerHtml) {
            html += `<div class="window-head">${options.headerHtml}</div>`;
        } else if (options.logo) {
            html += `<div class="bg-colored window-header" tabindex="0"><div class="window-header-logo"><img src="${community.logo}" alt="Community logo"/></div><div class="window-header-title"><h2 class="community-title" id="${titleid}">${options.header || ''}</h2></div><div class="window-header-justifier"></div></div>`
        } else if (options.header) {
            if (typeof options.header === 'string') {
                html += `<div class="window-head"><h2 id="${titleid}" tabindex="0">${options.header}</h2></div>`;
            } else if (typeof options.header === 'object') {
                html += `<div class="window-head">`;
                if (Object.hasOwn(options.header, 'title')) {
                    html += `<h2 id="${titleid}">${options.header.title}</h2>`;
                }
                if (Object.hasOwn(options.header, 'subtitle')) {
                    html += `<p>${options.header.subtitle}</p>`;
                }
                html += '</div>'
            }
        } else {
            // title must be added elsewhere
            // html += '<div class="window-head" aria-hidden="true"><h2>&nbsp;</h2></div>';
        }
        html += `<div class="window-body ${options.bodyClass || 'text'}">${options.content || ''}</div>`;

        if (options.footer) {
            html += `<div class="window-footer">${options.footer}</div>`;
        }
        html += '</div>'
        this.$ = $(html)
        this.attached = false
        this.events = [];
        this.$.on('closed.cc.modal', function () {
            this.destroy()
            this.opener.focus();
        }.bind(this))
    }

    show() {
        this.attach()
        window.openWindow(this.id)
        return this
    }

    attach() {
        if (!this.attached) {
            this.$.appendTo('body > .windows')
            this.attached = true
            docready(this.$.find('.window-body'))
        }
        return this
    }

    hide() {
        window.closeWindow(this.id)
        return this
    }

    destroy() {
        this.$.detach();
        this.attached = false;
        $('.modal-backdrop').remove();
        return this;
    }

    setContent(content) {
        if (typeof content === 'object') {
            window.appendJsTranslations(content.translations || {});
            if (content.hasOwnProperty('headerHtml') && content.headerHtml) {
                if (!this.$.find('.window-head').html(content.headerHtml).length) {
                    this.$.find('.window-body').before(`<div class="window-head">${content.headerHtml}</div>`)
                }
            } else if (content.hasOwnProperty('header')) {
                this.$.find('.window-head h2').html(content.header)
            }
            if (content.hasOwnProperty('body')) {
                this.$.find('.window-body').html(content.body)
            }
        } else {
            this.$.find('.window-body').html(content)
        }
        if (this.attached) {
            docready(this.$.find('.window-body'))
        }
        return this
    }

    setOpener(openerSrc = null) {
        openerSrc = openerSrc || "body";
        this.opener = isString(openerSrc) ? $(openerSrc || "body") : openerSrc;
    }

    async loadContent(options) {
        this.setOpener(options.opener || null);
        const content = (typeof options.url !== 'undefined') ? await $.ajax(options) : options;
        this.setContent(content);
        this.show()
        return this
    }


}
